import { gql } from '@apollo/client';
import { useMediaQuery } from '@mnd-frontend/hooks';
import { Box } from '@mnd-frontend/ui/publish/components';
import { greaterThan, media, remCalc } from '@mnd-frontend/ui/publish/utils';
import { GREY_300, SPACING_3 } from '@mnd-frontend/ui/shared/tokens';
import styled from 'styled-components';
import { useNewsroomSetup } from '../../contexts/NewsroomSetupContext';
import Branding from './components/Branding';
import CompanyDescription from './components/CompanyDescription';
import CompanyInformation from './components/CompanyInformation';
import GoLive from './components/GoLive';
import NewsroomPreview from './components/NewsroomPreview';
import PressContact from './components/PressContact';

gql`
  fragment PressroomGoLive on Pressroom {
    id
    ...PressContact
    newsroomSettings {
      id
      ...CompanyDescription
      ...CompanyInfo
      newsroomStyle {
        ...Branding
      }
    }
    source {
      id
      trusted
    }
  }
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  background: ${GREY_300};
  border-radius: 8px;
`;

const StepSection = styled.div`
  flex: 1;
  height: 100%;
  ${greaterThan('desktop')} {
    flex: 4;
    min-width: ${remCalc(400)};
    min-height: ${remCalc(880)};
    height: unset;
  }
`;

const PreviewSection = styled.div`
  flex: 6;
  display: flex;
  flex-direction: column;
  padding: ${SPACING_3};
  justify-content: center;
`;

const NewsroomSetupModal = () => {
  const { newsroomSetupStep, setNewsroomSetupStep } = useNewsroomSetup();
  const isDesktop = useMediaQuery(media.greaterThan('desktop'));

  const goLiveSteps = {
    branding: <Branding />,
    'press-contact': <PressContact />,
    'company-description': <CompanyDescription />,
    'company-info': <CompanyInformation />,
  };

  return (
    <Box
      openedAsModal={!!newsroomSetupStep}
      size="lg"
      bodyPadding={false}
      maxHeight="95vh"
      onClose={() => setNewsroomSetupStep(undefined)}
    >
      {newsroomSetupStep !== 'go-live' ? (
        <Wrapper>
          <StepSection id="step-section">
            {newsroomSetupStep && goLiveSteps[newsroomSetupStep]}
          </StepSection>
          {isDesktop && (
            <PreviewSection>
              <NewsroomPreview step={newsroomSetupStep} />
            </PreviewSection>
          )}
        </Wrapper>
      ) : (
        <GoLive />
      )}
    </Box>
  );
};

export default NewsroomSetupModal;
